// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}
.react-datepicker__input-container input:focus {
  border: 1px solid #3182ce; /* Change to your desired border color */
  outline: none;
}

/* Add custom border styles for the datepicker input */
.react-datepicker__input-container input {
  width: 200px;
  border: 1px solid #ccc; /* Default border color */
  border-radius: 4px; /* Rounded corners */
  padding: 8px 12px; /* Padding inside input */
}
.react-datepicker__view-calendar-icon input {
  padding: 5px 0px 2px 30px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,sBAAsB,EAAE,yBAAyB;EACjD,kBAAkB,EAAE,oBAAoB;EACxC,iBAAiB,EAAE,yBAAyB;AAC9C;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".App {\n  text-align: center;\n}\n.react-datepicker__input-container input:focus {\n  border: 1px solid #3182ce; /* Change to your desired border color */\n  outline: none;\n}\n\n/* Add custom border styles for the datepicker input */\n.react-datepicker__input-container input {\n  width: 200px;\n  border: 1px solid #ccc; /* Default border color */\n  border-radius: 4px; /* Rounded corners */\n  padding: 8px 12px; /* Padding inside input */\n}\n.react-datepicker__view-calendar-icon input {\n  padding: 5px 0px 2px 30px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
